

export const PARTICIPANT_STATUS_ONLINE = 'online',
    PARTICIPANT_STATUS_OFFLINE = 'offline'